var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11947 0.208252C0.84458 0.208252 0.580953 0.317449 0.38658 0.511823C0.192206 0.706197 0.0830078 0.969825 0.0830078 1.24471C0.0830078 1.5196 0.192206 1.78322 0.38658 1.9776C0.580953 2.17197 0.84458 2.28117 1.11947 2.28117H13.6299C13.9048 2.28117 14.1684 2.17197 14.3628 1.9776C14.5571 1.78322 14.6663 1.5196 14.6663 1.24471C14.6663 0.969825 14.5571 0.706197 14.3628 0.511823C14.1684 0.317449 13.9048 0.208252 13.6299 0.208252H1.11947Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0830078 7.31762C0.0830078 6.7447 0.547591 6.28116 1.11947 6.28116H19.8799C20.1548 6.28116 20.4184 6.39036 20.6128 6.58473C20.8071 6.7791 20.9163 7.04273 20.9163 7.31762C20.9163 7.5925 20.8071 7.85613 20.6128 8.0505C20.4184 8.24488 20.1548 8.35408 19.8799 8.35408H1.11947C0.84458 8.35408 0.580953 8.24488 0.38658 8.0505C0.192206 7.85613 0.0830078 7.5925 0.0830078 7.31762V7.31762Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0830078 13.3906C0.0830078 12.8176 0.547591 12.3541 1.11947 12.3541H9.46322C9.7381 12.3541 10.0017 12.4633 10.1961 12.6577C10.3905 12.852 10.4997 13.1157 10.4997 13.3906C10.4997 13.6654 10.3905 13.9291 10.1961 14.1234C10.0017 14.3178 9.7381 14.427 9.46322 14.427H1.11947C0.84458 14.427 0.580953 14.3178 0.386579 14.1234C0.192206 13.9291 0.0830078 13.6654 0.0830078 13.3906V13.3906Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu2.fc72923772ef4ed2cdbc4ad1be550430.svg";
export { ForwardRef as ReactComponent };